import { createSelector } from 'reselect';
import { Operation } from '../../models/types/Operation';

const operation = (state: { operation: Operation }) => state.operation;

// My Operation
const selectOperationInfos = createSelector(operation, (operation) => operation && operation.operationInfos);

const selectOperations = createSelector(operation, (operation) => operation.operations);

const selectLatestDateWithData = createSelector(operation, (operation) => operation && operation.latestDateWithData);

export { selectLatestDateWithData, selectOperationInfos, selectOperations };
